import { Fragment } from 'react'

import { m } from 'framer-motion'
import Image from 'next/image'

import CocOnboardingImageScreen2 from '@/assets/images/clashofclans/onboarding-image-screen-2.webp'

import { variants } from '../../../constants'

import styles from './styles.module.scss'

export const Screen2 = () => (
  <Fragment>
    <m.h1
      key="coc-screen-2-title"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.3, ease: 'easeInOut' }}
      className={styles.Title}
    >
      Discover Store Specials
    </m.h1>
    <m.div
      key="coc-screen-2-image"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
      className={styles.ItemArea}
    >
      <div className={styles.ItemImage}>
        <Image src={CocOnboardingImageScreen2} alt="" width={300} />
      </div>
    </m.div>
    <m.div
      key="coc-screen-2-footer"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
      className={styles.BottomText}
    >
      <p>These high-value offers only appear in the Clash of Clans Store.</p>
    </m.div>
  </Fragment>
)
